<template>
  <el-drawer v-loading="loading" :with-header="false" size="60%" :show-close="true" :visible.sync="drawer" :direction="direction" :before-close="handleClose" class="s_customer_chat_history">
    <!-- 消息列表和输入框容器 -->
    <div class="s-chat-middle-container g-flex-column">
      <div class="s-userinfo">
        <span>{{userInfo.ip_address}}</span>
        <span>{{userInfo.name}}</span>
      </div>
      
      <!-- 消息列表 -->
      <div class="s-chat-middle-content g-self-scrollbar" id="chatHistoryContent">
        
        <!-- 加载历史消息 -->
        <div class="s-reload-history g-flex-align-center g-flex-justify-center">
          <div class="s-reload-btn" @click="loadHistoryClick">
            <i class="iconfont icon-shangsanjiaoxing"></i>
            <span>{{finish ? '没有更多了': '查看之前的会话'}}</span>
          </div>
        </div>

        <!-- 消息列表 -->
        <ul class="s-chat-msg-list">
          <li class="s-chat-msg-item g-flex-column" v-for="(item, index) in msgList" :key="index" :class="item.send_type === 2 ? 'g-flex-align-end' : (item.send_type === 1 ? 'g-flex-align-start' : 's-chat-msg-item-system')">
            <!-- 系统转接消息 -->
            <div class="s-msg-item-sys" v-if="item.send_type === 0">
              {{item.msg}}
            </div>

            <!-- 发送时间 -->
            <div class="s-msg-item-time-name" v-show="item.send_type !== 0">
              <span class="s-msg-item-time">{{formatDate(item.create_time, 'MM-dd hh:mm:ss')}}</span>
              <span class="s-msg-item-name" v-show="item.send_type === 2">{{item.kefu_name}}</span>
            </div>

            <div class="s-msg-item-msg-box g-flex-align-center" v-show="item.send_type !== 0" >
              <div class="s-msg-item-msg" :class="item.send_type === 2 ? 's-i-send-bg': '' ">
                <!-- 发送失败 -->
                <div class="s-item-send-fail" v-show="item.send_type === 2 && item.fail">
                  <i class="iconfont icon-gantanhao"></i>
                </div>
                
                <!-- 是文字 -->
                <div v-html="item.msg" v-if="item.type === 0"></div>

                <!-- 是图片 -->
                <div v-if="item.type === 1" class="s-msg-item-image">
                  <el-image :src="JSON.parse(item.msg).filePath" alt="" fit="cover" :preview-src-list="[JSON.parse(item.msg).filePath]"/>
                </div>

                <!-- 是文件 -->
                <div v-if="item.type === 2" class="s-msg-item-file g-flex-align-center">
                  <i class="iconfont icon-wenjian1"></i>
                  <div class="s-file-right">
                    <p class="s-file-right-filename">{{JSON.parse(item.msg).fileName}}</p>
                    <span class="s-file-right-download" @click="downFileClick(item)">立即下载</span>
                  </div>
                </div>
              </div>
            </div>

          </li>
        </ul>
      </div>

      <!-- 底部输入消息框 -->
      <div class="s-chat-footer-box">
        <div class="s-chat-footer">
          <!-- 输入框 -->
          <div class="s-chat-footer-msg-send">
            <el-input @keyup.native="onShiftEnterKeyDown" type="textarea" class="g-self-scrollbar" :rows="4" placeholder="'Shift + Enter键' 发送" v-model="sendContent"></el-input>
            <el-button type="primary" class="s-end-btn" @click="sendMsgClick">发送</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
  import { apiGetCusDialogHistory, apiSendMsg } from '@/utils/api.js'
  import { formatDate } from '@/utils/index.js';
  export default {
    data() {
      return {
        drawer: false,
        direction: 'rtl',

        loadFlag: true, //节流阀 一次请求是否完毕

        msgList: [],

        loading: false,

        finish: false, //是否加载完毕

        userInfo: {},

        sendContent: '', // 发送内容

        kefuUserInfo: this.$global.adminUser // 客服信息
      }
    },
    methods: {
      formatDate,

      handleClose() {
        this.resetData()
      },

      resetData() {
        this.finish = false
        this.userInfo = {}
        this.msgList = []
        this.loadFlag = true
        this.loading = false
        this.drawer = false
        this.sendContent = ''
      },
      
      onShow(obj) {
        this.userInfo = obj
        this.loadHistoryClick()
        this.drawer = true
      },

      // 查看历史消息
      async loadHistoryClick() {
        // 是否请求完成 或者是否已经加载完毕了
        if(!this.loadFlag || this.finish) return
        this.loadFlag = false
        let msgId = 0 
        if(this.msgList.length) msgId = this.msgList[0].id
        this.loading = true
        const { success, data } = await apiGetCusDialogHistory({ user_id: this.userInfo.id, id: msgId })
        this.loading = false
        if(!success) return
        if(data.list.length < 5) this.finish = true
        this.msgList.reverse()
        data.list.forEach((item) => { 
          this.msgList.push(item) 
        })
        this.msgList.reverse()
        // 请求已完成 可以进行下次
        this.loadFlag = true
        // console.log(data)
      },

      // 下载
      downFileClick(item) {
        let a = document.createElement('a')
        a.setAttribute('href', JSON.parse(item.msg).filePath)
        a.setAttribute('download', "")
        a.click()
      },

      // Shift + Enter 发送
      onShiftEnterKeyDown(event) {
        if (event.keyCode === 13 && event.shiftKey) {
          this.sendMsgClick()
        }
      },

      // 发送消息
      async sendMsgClick() {
        if (!this.sendContent.trim().length) return
        let htmlStr = this.sendContent.replace(/\n/g, "<br>")
        let sendItem = {
          kefu_name: this.kefuUserInfo.name,
          msg: htmlStr,
          send_type: 2,
          type: 0,
          create_time: parseInt(new Date().getTime() / 1000),
          id: this.userInfo.id
        }
        this.msgList.push(sendItem)
        this.sendContent = ""
        this.scrollToBottom()
        const { success, data } = await apiSendMsg(sendItem).catch(() => {
          this.$set(this.msgList[this.msgList.indexOf(sendItem)], 'fail', true)
          return { success: false }
        })
        if (!success) {
          this.$set(this.msgList[this.msgList.indexOf(sendItem)], 'fail', true)
          return
        }
        sendItem.id = data.data.id
      },

      // 滚动到底部
      scrollToBottom() {
        this.$nextTick(() => {
          let scrollDom = document.getElementById('chatHistoryContent')
          if (scrollDom) {
            scrollDom.scrollTop = scrollDom.scrollHeight
          }
        })
      },

    }
  }
</script>

<style lang="scss">
.s_customer_chat_history {
  height: 100%;
  overflow-y: auto;
  .el-drawer {
    outline: none;
    .el-drawer__body {
      background: $chatContainerBg;
      outline: none;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
    }
  }

    // 消息列表和输入框容器 
  .s-chat-middle-container {
    flex: 1;
    overflow-y: auto;
    .s-userinfo {
      padding: 10px;
      border-bottom: 1px solid #d8dce5;
      span {
        font-size: $small-more-font-size;
        color: #606266;
        &:nth-of-type(2) {
          padding-left: 10px;
        }
      }
    }
    // 消息列表
    .s-chat-middle-content {
      padding: 10px 16px;
      flex: 1;
      overflow-y: auto;
      // 加载历史消息
      .s-reload-history {
        padding-bottom: 10px;
        margin-top: -10px;
        .s-reload-btn {
          background: $white;
          padding: 6px 10px;
          border-radius: 0 0 4px 4px;
          box-shadow: 0 0 20px 0 rgba(52, 63, 75, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.04);
          cursor: pointer;
          color: $mainBlue;
          font-size: $most-font-size;
          i {
            font-size: 16px;
            padding-right: 10px;
          }
        }
      }

      // 聊天列表
      .s-chat-msg-list {
        margin: 30px 0;
        margin-bottom: 10px;
        .s-chat-msg-item {
          padding-bottom: 15px;
          &.s-chat-msg-item-system {
            .s-msg-item-sys {
              color: $mainBlue;
              font-size: $small-more-font-size;
              text-align: center;
            }
          }
          .s-msg-item-time-name {
            font-size: $most-font-size;
            .s-msg-item-time {
              color: $noActiveFontColor;
            }
            .s-msg-item-name {
              padding-left: 5px;
              color: $fontColor;
            }
          }
        }
        // 消息
        .s-msg-item-msg-box {
          padding-top: 8px;
          .s-msg-item-msg {
            background: $msgBgColor;
            padding: 10px 12px;
            max-width: 450px;
            word-break: break-all;
            border-radius: 4px;
            color: $fontColor;
            font-size: $small-more-font-size;
            line-height: 24px;
            position: relative;
            &.s-i-send-bg {
              background: $white;
            }
            .s-item-send-fail {
              position: absolute;
              left: -10px;
              top: 50%;
              transform: translateX(-100%) translateY(-50%);
              i {
                color: red;
              }
            }

            // 图片
            .s-msg-item-image {
              img {
                max-width: 420px;
                vertical-align: middle;
                object-fit: cover;
              }
            }

            // 文件
            .s-msg-item-file {
              min-width: 180px;
              .icon-wenjian1 {
                font-size: 40px;
              }
              .s-file-right {
                flex: 1;
                padding-left: 10px;
                p {
                  font-size: $small-font-size;
                  color: $fontColor;
                  max-width: 300px;
                  @include textEllipsis();
                }
                span {
                  cursor: pointer;
                  font-size: $small-more-font-size;
                  color: $mainBlue;
                }
              }
            }
          }
        }
      }

      // 上传进度条
      .s-chat-uploading-box {
        padding: 10px 0px;
        width: 100%;
        .s-chat-uploading {
          border-radius: 4px;
          min-width: 180px;
          max-width: 320px;
          padding: 10px 12px;
          background: $white;
          .s-uploading-left {
            i {
              font-size: 40px;
            }
          }
          .s-uploading-right {
            padding-left: 10px;
            flex: 1;
            .s-uploading-filename {
              width: 180px;
              @include textEllipsis()
            }
          }
        }
      }
    }

    // 底部输入消息框
    .s-chat-footer-box {
      padding: 0 16px 16px;
      .s-chat-footer {
        background: $white;
        border-radius: 6px;
        box-shadow: 0 1px 8px 1px rgba(53, 56, 63, 0.1);
        // 发送消息的input和按钮
        .s-chat-footer-msg-send {
          position: relative;
          padding-bottom: 40px;
          .el-textarea__inner {
            white-space: pre-wrap;
            width: 100%;
            border: none;
            outline: none;
            resize: none;
            color: $fontColor;
          }
          .s-end-btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
            background: $mainBlue;
            padding: 8px 16px;
          }
        }
      }
    }
  }
}
</style>